import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const JoinForm = ({ onJoined }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/groups/join", { code: code.trim() });
      toast.success(r.data.status === "active" ? `You're already in ${r.data.name}` : `Request sent to ${r.data.name} — the admin needs to approve you`);
      setCode("");
      onJoined();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't join");
    } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="group-join-form">
      <div className="relative flex-1">
        <KeyRound className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-[#6B7280]" />
        <input data-testid="group-join-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={12}
          placeholder="Have an invite code?" className="w-full h-10 pl-10 pr-3 rounded-full bg-[#1E1E1E] border border-[#27272A] text-sm font-mono tracking-wider text-[#F3F4F6] placeholder:text-[#6B7280] placeholder:font-sans placeholder:tracking-normal focus:outline-none focus:border-[#3B82F6]" />
      </div>
      <button type="submit" disabled={busy || !code.trim()} data-testid="group-join-btn"
        className="h-10 px-4 rounded-full bg-[#1E1E1E] border border-[#27272A] text-sm text-[#F3F4F6] hover:border-[#3B82F6] disabled:opacity-40">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Join"}
      </button>
    </form>
  );
};
